'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.pushCartReducer = pushCartReducer;

var _pushCartTypes = require('../types/push-cart-types');

var pushCartTypes = _interopRequireWildcard(_pushCartTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var initialState = {
  errors: [],
  itemBeingAddedId: null,
  itemCount: 0,
  lineItems: [],
  loading: false,
  subtotal: 0
};

function pushCartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case pushCartTypes.SET_ITEM_BEING_ADDED_ID:
      {
        return (0, _assign2.default)({}, state, {
          itemBeingAddedId: payload.id
        });
      }
    case pushCartTypes.SET_LOADING:
      {
        return (0, _assign2.default)({}, state, {
          loading: payload
        });
      }
    case pushCartTypes.ADD_ERROR:
      {
        return (0, _assign2.default)({}, state, {
          errors: [].concat((0, _toConsumableArray3.default)(state.errors), [payload.error])
        });
      }
    case pushCartTypes.TOGGLE_ERROR:
      {
        return (0, _assign2.default)({}, state, {
          errors: state.errors.map(function (error) {
            error.show = error.key === payload.key ? error.show = !error.show : error.show;

            return error;
          })
        });
      }
    case pushCartTypes.REMOVE_ERROR:
      {
        return (0, _assign2.default)({}, state, {
          errors: state.errors.filter(function (error) {
            return error.key !== payload.key;
          })
        });
      }
    case pushCartTypes.REMOVE_ALL_ERRORS:
      {
        return (0, _assign2.default)({}, state, {
          errors: []
        });
      }
    case pushCartTypes.UPDATE_LINE_ITEMS:
      {
        return (0, _assign2.default)({}, state, {
          lineItems: payload.data.items,
          itemCount: payload.data.item_count,
          subtotal: payload.data.total_price
        });
      }
    default:
      return state;
  }
}